<template>
  <div class="gjjl-container">
    <el-row class="tcf-row">
      <el-col  class="card">
        <div class="card-body">
          <div class="card-title">
            跟进记录
            <div class="search-mode">
              <input type="text" class="search-input" @keyup.enter="Search" placeholder="关键字搜索" v-model="search" />
              <el-button class="search-btn" icon="el-icon-search" @click="Search"/>
            </div>
          </div>
          <div class="card-content" >
            <el-row>
              <el-col :span="5">
                <ul class="group-filter">
                  <li :class="type===0?'active':''" @click="change(0)">全部</li>
                  <li :class="type===3?'active':''" @click="change(3)">待跟进</li>
                  <li :class="type===1?'active':''" @click="change(1)">即将回收</li>
                  <li :class="type===2?'active':''" @click="change(2)">已签约</li>
                </ul>
              </el-col>
              <el-col :span="19" v-loading="loading">
                <el-table
                  :data="tableData"
                  :show-header="false"
                  :row-style="{cursor: 'pointer'}"
                  @row-click="openDetails"
                  style="width: 100%">
                  <el-table-column
                    label="客户状态"
                    width="80"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <el-tag :disable-transitions="true" type="warning" size="mini" v-if="scope.row.is_recycle!=1 && scope.row.label==2">待跟进</el-tag>
                      <el-tag :disable-transitions="true" type="danger" size="mini" v-if="scope.row.is_recycle==1 && scope.row.label==2">即将回收</el-tag>
                      <el-tag :disable-transitions="true" size="mini" v-if="scope.row.label>=3">已签约</el-tag>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="客户名称"
                    width="100"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span style="color:#000;margin-right: 10px">{{scope.row.client_name}}</span>
                      <svg-icon icon-class="client_man" class="client-sex" v-if="scope.row.sex === 1" />
                      <svg-icon icon-class="client_women" class="client-sex" v-if="scope.row.sex === 0" />
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="跟进时间"
                    width="160"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span><i class="el-icon-time"></i> {{scope.row.follow_time}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="跟进内容"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span>{{scope.row.follow_content}}</span>
                    </template>
                  </el-table-column>
                </el-table>
                <el-pagination
                  v-if="total>0"
                  background
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                  :current-page="currentPage"
                  :page-sizes="[20, 50, 100]"
                  :page-size="pageSize"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="total">
                </el-pagination>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { getUser } from '@/utils/auth'
import { getUserFollowRecord } from '@/api/work'

export default {
  name: 'gjjl',
  computed: {
    user: getUser
  },
  data() {
    return {
      search: '',
      type: 0,
      loading: false,
      tableData: [],
      currentPage: 1,
      pageSize: 20,
      total: 0
    }
  },
  created() {
    this.getData()
  },
  methods: {
    change(n) {
      if (this.type === n) {
        return false
      }
      this.type = n
      this.getData()
    },
    Search() {
      if (this.search != null && this.search.trim() != '') {
        this.currentPage = 1
        this.getData()
      } else {
        this.search = ''
        this.getData()
      }
    },
    getData() {
      this.loading = true
      const data = {
        userid: this.user.dUserid,
        type: this.type,
        content: this.search,
        page: this.currentPage,
        limit: this.pageSize
      }
      getUserFollowRecord(data).then(response => {
        this.loading = false
        this.tableData = response.data
        this.total = response.total
      }).catch(() => {
        this.loading = false
      })
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.getData()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.getData()
    },
    openDetails(row) {
      this.$router.push({ path: '/work/client/' + row.client_id })
    }
  }
}
</script>

<style lang="scss" scoped>
.gjjl-container {
  .group-container{
    width: 100%;
    position: relative;
    padding: 20px;
    .group-item{
      position: relative;
      padding: 9px 15px;
      background: #FFF;
      border: 1px dashed #DCDFE6;
      border-radius: 4px;
      display: inline-block;
      color: #606266;
      font-size: 12px;
      font-weight: 500;
      margin:0 20px 20px 0;
      .group-del{
        padding: 2px!important;
        font-size: 10px!important;
        position: absolute;
        right: -10px;
        top: -6px;
      }
    }
  }
  .tcf-row{
    .card{
      .card-body{
        .card-title{
          .search-mode{
            width: 300px;
            position: relative;
            float: right;
            margin-top: -10px;
            .search-input{
              background-color: #F2F6FC;
              border:0;
              height: 40px;
              line-height: 40px;
              border-radius: 4px;
              color: #606266;
              padding: 0 40px 0 15px;
              -webkit-appearance: none;
              font-size: 12px;
              width: 100%;
              -webkit-box-sizing: border-box;
              box-sizing: border-box;
              outline: 0;
              &::-webkit-input-placeholder {
                color: #C0C4CC;
              }
              &::-ms-input-placeholder {
                color: #C0C4CC;
              }
            }
            .search-btn{
              position: absolute;
              right: 0;
              height: 40px;
              width: 40px;
              line-height: 40px;
              top: 0;
              border: 0;
              background: transparent;
              text-align: center;
              padding: 0;
            }
          }
        }
        .card-content{
          .group-filter{
            width: 100%;
            padding: 0 30px 0 0 ;
            margin: 0 ;
            position: relative;
            li{
              width: 100%;
              list-style: none;
              position: relative;
              padding-left: 20px;
              padding-top: 15px;
              padding-bottom: 15px;
              cursor: pointer;
              border-radius: 2px;
              text-overflow: ellipsis;
              overflow: hidden;
              white-space: nowrap;
              &.active{
                background: #f5f7fa;
                color:#409EFF;
              }
              &:hover{
                color:#409EFF;
              }
            }
          }
          .client-sex{
            width: 16px!important;
            height: 16px!important;
            vertical-align: -4px!important;
          }
          .el-table::before{
            height: 0!important;
          }
          .el-pagination{
            margin-top: 20px;
          }
        }
      }
    }
  }
}
</style>
